import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate';

Vue.use(Vuex)

// admin store
import CodeMngt from './modules/admin/codeMngt.js'
import MedicineMngt from './modules/admin/medicineMngt.js'
import MedWrhsMngt from './modules/admin/medWrhsMngt.js'
import NoticeMngt from './modules/admin/noticeMngt.js'
import WrapperMngt from './modules/admin/wrapperMngt.js'
import DictionaryMngt from './modules/admin/dictionaryMngt.js'
import commonStore from './modules/admin/commonStore.js'
import PromiseMngt from './modules/admin/promiseMngt.js'
import promiseWhrsMngt from './modules/admin/promiseWhrsMngt.js'
import userMngt from './modules/admin/userMngt.js'
import orderPaymentMngt from './modules/admin/orderPaymentMngt.js'
import mngrMbrMngt from './modules/admin/mngrMbrMngt.js'
import menuStore from './modules/admin/menuStore.js'


// user store
import clinicDoctorInfo from './modules/user/clinicDoctorInfo.js'
import applicationInfo from './modules/user/applicationInfo.js'
import promiseGoodsInfo from './modules/user/promiseGoodsInfo.js'
import tangjunInfo from './modules/user/tangjunInfo.js'
import paymentInfo from './modules/user/paymentInfo.js'

//common
import detailSearchInfo from './modules/common/detailSearchInfo.js'

const store = new Vuex.Store({
    modules: {
        codeMngt: CodeMngt,
        medicine: MedicineMngt,
        medWrhs: MedWrhsMngt,
        notice: NoticeMngt,
        wrapper: WrapperMngt,
        dictionary: DictionaryMngt,
        commonStore: commonStore,
        clinicDoctorInfo: clinicDoctorInfo,
        applicationInfo : applicationInfo,
        promise : PromiseMngt,
        promiseWhrs : promiseWhrsMngt,
        promiseGoodsInfo : promiseGoodsInfo,
        tangjunInfo : tangjunInfo,
        userMngt : userMngt,
        orderPaymentMngt : orderPaymentMngt,
        detailSearchInfo : detailSearchInfo,
        paymentInfo : paymentInfo,
        mngrMbrMngt: mngrMbrMngt,
        menuStore:menuStore
    },
    plugins: [

        //관리자 - 브라우저 종료 시 초기화 (sessionStorage)
        createPersistedState({
            key: 'admin-session',
            storage: window.sessionStorage,
            paths: ['mngrMbrMngt','menuStore']
        }),

        //사용자 - 브라우저 종료 시 초기화 (sessionStorage)
        createPersistedState({
            key: 'user-session',
            storage: window.sessionStorage,
            paths: ['commonStore','clinicDoctorInfo','apllicationInfo','promiseGoodsInfo','detailSearchInfo']
        }),

        //브라우저 꺼도 유지 (localStorage)
        // createPersistedState({
        //     key: 'user-store',
        //     storage: window.localStorage,  // 또는 생략
        //     paths: ['user']
        // }),
      ]
})

export default store